/**
 * created on: 2019.04.08
 */
'use strict'
angular.module('broadcastManageServiceModule', [
        'createBroadcastModule',
        'createBroadcastChannelModule',
        'broadcastInputPasswordModule'
    ])
    .factory('broadcastManageService', ['$q', 'trsHttpService', 'globleParamsSet', '$modal', 'modalDialog', function($q, trsHttpService, globleParamsSet, $modal, modalDialog) {
        return {
            /**
             * [createTelevision 新建电视站点]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            createBroadcast: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/broadcast/service/createBroadcast/createBroadcast_tpl.html",
                    windowClass: 'newBroadcast',
                    backdrop: false,
                    resolve: {
                        broadcastBaseData: function() {
                            return item;
                        }
                    },
                    controller: 'createBroadcastCtrl'
                });
                modalInstance.result.then(function(success) {
                    defer.resolve(success);
                }, function(error) {
                    defer.reject('fail');
                });
                return defer.promise;
            },
            /**
             * [createChannel 新建电视栏目]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            createChannel: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/broadcast/service/createChannel/createChannel_tpl.html",
                    windowClass: 'newBroadcastChannel',
                    backdrop: false,
                    resolve: {
                        channelBaseData: function() {
                            return item;
                        }
                    },
                    controller: 'createBroadcastChannelCtrl'
                });
                modalInstance.result.then(function(success) {
                    defer.resolve(success);
                }, function(error) {});
                return defer.promise;
            },
            /**
             * [inputPassword 密码弹窗]
             * @return {[type]} [description]
             */
            inputPassword: function() {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/broadcast/service/inputPassword/inputPassword_tpl.html",
                    windowClass: 'productManageMent-broadcast-channel-delete',
                    backdrop: false,
                    controller: "broadcastInputPasswordCtrl"
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                });
                return defer.promise;
            },
            /**
             * [getRight description]获取栏目或站点的操作权限
             * @return object [description]
             */
            getRight: function(siteId, channelId, classify) {
                var deffer = $q.defer();
                var params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryOperKeyById",
                    SiteId: siteId,
                    ChannelId: channelId,
                    Classify: classify
                };
                if (siteId === "") {
                    delete params.SiteId;
                } else {
                    delete params.ChannelId;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    });
                return deffer.promise;
            },
            /**
             * [getOperType description]获取可以看到或操作的底部标签 如：频道管理，碎片化管理，模板管理，分发配置
             * @return object [description]
             */
            getChannelAccessAuthority: function(siteId) {
                var deffer = $q.defer();
                this.getOperType(siteId, "").then(function(data) {
                    var router = "";
                    for (var key in data) {
                        switch (key) {
                            case "channel":
                                router += "channel";
                                break;
                            case "template":
                                router += "template";
                                break;
                                // wf add 4.16
                            case "mark":
                                router += "watermarkmgr";
                                break;
                        }
                        break;
                    }
                    if (router === "") {
                        modalDialog.alertType("", "您无权查看该站点下的栏目", "error", true);
                    } else {
                        deffer.resolve({ data: data, router: router });
                    }
                });
                return deffer.promise;
            },
            /**
             * [getOperType description]获取可以看到或操作的底部标签 如：频道管理，碎片化管理，模板管理，分发配置
             * @return object [description]
             */
            getOperType: function(siteId, channelId) {
                var deffer = $q.defer();
                var params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryOperTypesByTvBaseChnlId",
                    ChannelId: channelId,
                    SiteId: siteId
                };
                if (siteId === "") {
                    delete params.SiteId;
                } else {
                    delete params.ChannelId;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    });
                return deffer.promise;
            }
        };
    }]);